// extracted by mini-css-extract-plugin
module.exports =  {"container":"N7mVzWa","ratings-count":"khO62BA","ratingsCount":"khO62BA"};